// Module
var code = "<div layout=\"column\"> <span class=\"value\" ng-style=\"{'color': $ctrl.color}\">{{$ctrl.value}}</span> </div> ";
// Exports
export default code;